module.exports = __webpack_public_path__ + "img/Poorter_hotel-113.bf42e963.jpg";